/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCrmTokenInfo } from '../../models/api-response-crm-token-info';

export interface Status$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function status(http: HttpClient, rootUrl: string, params: Status$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCrmTokenInfo>> {
  const rb = new RequestBuilder(rootUrl, status.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCrmTokenInfo>;
    })
  );
}

status.PATH = '/v1/api/ui/zoho-crm/status';
